import React from "react";
import { UserDeviceSettingsTabHeadersTemplate } from "themes/administration/user/components";

function UserDeviceSettingsTabHeaders(props) {
    return <UserDeviceSettingsTabHeadersTemplate {...props} />;
}

export default UserDeviceSettingsTabHeaders;
